import React__default from 'react';
import Box from '../../Box/index.esm.js';
import Icon from '../../Icon/index.esm.js';
import Flex from '../../Flex/index.esm.js';
import { addMonths, format } from 'date-fns';
import { FROM_YEAR, MAX_PAGE } from '../constants.esm.js';

var HeaderButton = function HeaderButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  return React__default.createElement(Box, {
    textColor: ['text-blue-500', 'hover:text-blue-400'],
    cursor: "cursor-pointer",
    onClick: onClick
  }, children);
};

var PickerHeader = function PickerHeader(_ref2) {
  var calendarState = _ref2.calendarState,
      setCalendarState = _ref2.setCalendarState,
      monthYear = _ref2.monthYear,
      setMonthYear = _ref2.setMonthYear,
      headerHeight = _ref2.headerHeight,
      size = _ref2.size,
      page = _ref2.page,
      setPage = _ref2.setPage,
      displayYear = _ref2.displayYear,
      setDisplayYear = _ref2.setDisplayYear;

  if (calendarState === 'MONTH') {
    return React__default.createElement(Flex, {
      position: "absolute",
      inset: "top-0",
      zIndex: "z-50",
      width: "w-full",
      backgroundColor: "bg-white",
      alignItems: "items-center",
      justifyContent: "justify-between",
      padding: size === 'sm' ? 'px-3' : 'px-4',
      fontSize: size === 'sm' ? 'text-sm' : 'text-base',
      style: {
        height: headerHeight
      },
      onClick: function onClick() {
        return setCalendarState('DAY');
      }
    }, React__default.createElement(HeaderButton, {
      onClick: function onClick(e) {
        e.stopPropagation();
        setDisplayYear(Math.max(displayYear - 1, FROM_YEAR));
      }
    }, React__default.createElement(Icon, {
      name: "chevron-left"
    })), React__default.createElement(HeaderButton, null, displayYear), React__default.createElement(HeaderButton, {
      onClick: function onClick(e) {
        e.stopPropagation();
        setDisplayYear(Math.min(displayYear + 1, FROM_YEAR + 12 * MAX_PAGE - 1));
      }
    }, React__default.createElement(Icon, {
      name: "chevron-right"
    })));
  }

  if (calendarState === 'YEAR') {
    return React__default.createElement(Flex, {
      position: "absolute",
      inset: "top-0",
      zIndex: "z-50",
      width: "w-full",
      backgroundColor: "bg-white",
      alignItems: "items-center",
      justifyContent: "justify-between",
      padding: size === 'sm' ? 'px-3' : 'px-4',
      fontSize: size === 'sm' ? 'text-sm' : 'text-base',
      style: {
        height: headerHeight
      },
      onClick: function onClick() {
        return setCalendarState('DAY');
      }
    }, React__default.createElement(HeaderButton, {
      onClick: function onClick(e) {
        e.stopPropagation();
        setPage(Math.max(page - 1, 0));
      }
    }, React__default.createElement(Icon, {
      name: "chevron-left"
    })), React__default.createElement(HeaderButton, null, FROM_YEAR + page * 12 + " - " + (FROM_YEAR + page * 12 + 11)), React__default.createElement(HeaderButton, {
      onClick: function onClick(e) {
        e.stopPropagation();
        setPage(Math.min(page + 1, MAX_PAGE));
      }
    }, React__default.createElement(Icon, {
      name: "chevron-right"
    })));
  }

  return React__default.createElement(Flex, {
    position: "absolute",
    inset: "top-0",
    zIndex: "z-50",
    width: "w-full",
    backgroundColor: "bg-white",
    alignItems: "items-center",
    justifyContent: "justify-between",
    padding: size === 'sm' ? 'px-3' : 'px-4',
    fontSize: size === 'sm' ? 'text-sm' : 'text-base',
    style: {
      height: headerHeight
    }
  }, React__default.createElement(HeaderButton, {
    onClick: function onClick() {
      setMonthYear(addMonths(monthYear, -1));
    }
  }, React__default.createElement(Icon, {
    name: "chevron-left",
    size: size
  })), React__default.createElement(Flex, {
    gap: "gap-x-2"
  }, React__default.createElement(HeaderButton, {
    onClick: function onClick() {
      return setCalendarState('MONTH');
    }
  }, format(monthYear, 'MMMM')), React__default.createElement(HeaderButton, {
    onClick: function onClick() {
      return setCalendarState('YEAR');
    }
  }, format(monthYear, 'yyyy'))), React__default.createElement(HeaderButton, {
    onClick: function onClick() {
      setMonthYear(addMonths(monthYear, 1));
    }
  }, React__default.createElement(Icon, {
    name: "chevron-right",
    size: size
  })));
};

export default PickerHeader;
//# sourceMappingURL=PickerHeader.esm.js.map
